import { createContext, useContext } from 'react';

export const MeterBarChartLoadingContext = createContext(false);

export const useMeterBarChartLoading = () =>
  useContext(MeterBarChartLoadingContext);
